const state = {
    transactions: [],    
    loading: false
};

export default state;